import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class CMPService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  init(src: string) {
    this._addCustomStyles();
    this._initScript(src);
  }

  private _addCustomStyles() {
    const style = this.document.createElement('style');
    style.textContent = `
    #cookiescript_setting_advertising_wrap .cookiescript-iab-headerActionSeparator {
      display: none !important;
    }
    #cookiescript_setting_advertising_wrap .cookiescript-iab-headerActions .cookiescript-iab-headerAction:last-child {
     display: none !important;
    }
    `;
    this.document.head.appendChild(style);
  }

  private _initScript(src: string) {
    const script = this.document.createElement('script') as HTMLScriptElement;
    script.type = 'text/javascript';
    script.src = src;

    this.document.head.appendChild(script);
  }
}
